module.exports = __webpack_public_path__ + "assets/img/Vue.978de59c.png";